<template>
  <div>
    <Toolbar :title="questionnaire.title" />

    <div class="md-layout md-alignment-center-center questionarea">
      <div
        class="md-layout-item md-xlarge-size-33 md-large-size-33 md-medium-size-50 md-small-size-66 md-xsmall-size-100"
      >
        <md-empty-state
          v-if="question == false"
          class="md-primary"
          md-icon="done"
          md-label="You're done!"
          md-description="Es scheint, als könntest du alle Fragen aus diesem Fragenkatalog bereits auswendig."
        >
        </md-empty-state>

        <!-- QUESTION ANSWERED -->
        <md-card
          class="questioncard md-accent round-corners"
          v-else-if="selectedAnswer"
          :class="{
            true: selectedAnswer.is_correct,
            false: !selectedAnswer.is_correct,
          }"
        >
          <div class="questioncard-content">
            <md-card-header>
              <h1 class="md-title">
                {{ question.question }}
              </h1>
              <h2 class="md-subheading">
                <small v-if="inDevelopment"
                  >({{ question.id }} @ score: {{ question.score }})</small
                >
              </h2>
            </md-card-header>
            <md-card-content>
              <ul>
                <label v-for="answer in question.answers" :key="answer.id">
                  <li
                    class="md-elevation-10 round-corners"
                    :class="{
                      checked: selectedAnswer.answers.includes(answer.id),
                    }"
                  >
                    <div class="md-layout">
                      <input
                        type="checkbox"
                        disabled="true"
                        v-model="selectedAnswer.answers"
                        :value="answer.id"
                      />
                      <div class="md-layout-item">
                        {{ answer.answer }}
                        <small class="md-caption" v-if="inDevelopment">
                          {{ answer.is_correct ? "V" : "X" }}</small
                        >
                      </div>
                      <div class="md-layout-item md-size-5">
                        <md-icon v-if="answer.is_correct" class="answer-icon"
                          >check_circle</md-icon
                        ><md-icon v-else class="answer-icon">cancel</md-icon>
                      </div>
                    </div>
                  </li>
                </label>
              </ul>
            </md-card-content>
            <md-card-actions>
              <md-button @click="nextQuestion">Nächste Frage</md-button>
            </md-card-actions>
          </div>
        </md-card>

        <!-- QUESTION NOT ANSWERED -->
        <md-card
          v-else-if="question"
          class="questioncard md-accent round-corners"
        >
          <form @submit="formHandler">
            <div class="questioncard-content">
              <!-- QUESTION -->
              <md-card-header>
                <h1 class="md-title">
                  {{ question.question }}
                </h1>
                <h2 class="md-subheading">
                  <small v-if="inDevelopment"
                    >({{ question.id }} @ score: {{ question.score }})</small
                  >
                </h2>
              </md-card-header>
              <!-- ANSWER -->
              <md-card-content>
                <div
                  v-if="errors.length"
                  style="border: 2px solid #f00; padding: 10px;"
                >
                  <p>
                    <strong>Deine Antwort konnte nicht überpüft werden.</strong>
                  </p>
                  <ul>
                    <li v-for="error in errors" :key="error">{{ error }}</li>
                  </ul>
                </div>

                <ul>
                  <label v-for="answer in question.answers" :key="answer.id">
                    <li
                      class="md-elevation-10 round-corners"
                      :class="{ checked: selection.includes(answer.id) }"
                    >
                      <div class="md-layout">
                        <input
                          type="checkbox"
                          v-model="selection"
                          :value="answer.id"
                          @change="AnswerStatus"
                        />
                        <div class="md-layout-item">
                          {{ answer.answer }}
                          <small class="md-caption" v-if="inDevelopment">
                            {{ answer.is_correct ? "V" : "X" }}</small
                          >
                        </div>
                        <div class="md-layout-item md-size-5"></div>
                      </div>
                    </li>
                  </label>
                </ul>
              </md-card-content>
              <md-card-actions>
                <md-button @click="skipQuestion">Frage überspringen</md-button>
                <md-button type="submit" class="md-raised md-primary"
                  >Überprüfen</md-button
                >
              </md-card-actions>
            </div>
          </form>
        </md-card>
        <md-card v-else class="questioncard md-accent round-corners"
          >Thinking about your next question ..</md-card
        >
      </div>
    </div>
    <md-speed-dial
      v-if="$store.state[this.identifier].certificate"
      class="md-top-right"
      md-direction="top"
      style="z-index: 99999;"
    >
      <md-speed-dial-target
        :to="`/${this.identifier}/certificate`"
        class="md-primary"
      >
        <md-icon>verified</md-icon>
      </md-speed-dial-target>
    </md-speed-dial>
    <div v-else-if="isQualified">
      <CertificateForm
        :identifier="identifier"
        :showDialog="showCertificate"
        @hideDialog="showCertificate = false"
      />
    </div>
    <QuestionnaireStats
      v-if="inProcess && !$store.state[this.identifier].certificate"
      :questionnaire="questionnaire"
      fab
    />
  </div>
</template>

<script>
import CertificateForm from "./CertificateForm.vue";
import Toolbar from "./Toolbar.vue";
import QuestionnaireStats from "./QuestionnaireStats.vue";

export default {
  name: "Questions",
  props: {
    identifier: {
      type: String,
      required: true,
    },
  },
  components: {
    CertificateForm,
    Toolbar,
    QuestionnaireStats,
  },
  methods: {
    async formHandler(event) {
      event.preventDefault();
      this.errors = [];

      if (!this.selection.length) {
        this.errors.push("Bitte wähle mindestens eine Antwort aus.");
        return;
      }

      this.selectedAnswer = await this.$store.dispatch(
        `${this.identifier}/answerQuestion`,
        {
          question: this.question.id,
          answers: this.selection,
          date: new Date(),
        }
      );
      this.trail({
        type: "question-submit",
        questionnaire: this.identifier,
        question: this.question.id,
        answers: this.selection,
        is_correct: this.selectedAnswer.is_correct,
      });
    },
    async AnswerStatus() {
      this.trail({
        type: "answer-status",
        questionnaire: this.identifier,
        question: this.question.id,
        answers: this.selection,
      });
    },
    async selectQuestion() {
      const question = await this.$store.dispatch(
        `${this.identifier}/selectQuestion`
      );
      if (question) {
        this.trail({
          type: "question-show",
          questionnaire: this.identifier,
          question: question.id,
        });
      }
      return question;
    },
    async skipQuestion() {
      this.trail({
        type: "question-skip",
        questionnaire: this.identifier,
        question: this.question.id,
        answers: this.selection,
      });
      this.nextQuestion();
    },
    async nextQuestion() {
      this.selectedAnswer = null;
      this.selection = [];
      this.question = await this.selectQuestion();
    },
  },
  async mounted() {
    Promise.race([
      new Promise((resolve) => {
        this.$store.subscribe(async (mutation) => {
          const [questionnaire] = mutation.type.split("/");

          if (this.identifier == questionnaire) {
            resolve();
          }
        });
      }),
      new Promise((resolve) => {
        if (this.$store.state[this.identifier].questions.length) {
          resolve();
        }
      }),
    ]).then(async () => {
      this.question = await this.selectQuestion();
    });

    this.$store.dispatch("setQuestionnaire", this.identifier);
    this.questionnaire = this.$store.state.questionnaires[this.identifier];
  },
  computed: {
    inDevelopment() {
      return process.env.NODE_ENV !== "production";
    },
    stats() {
      return (
        this.$store.getters[`${this.questionnaire.identifier}/stats`] || {}
      );
    },
    isQualified() {
      if (this.stats.qualified) {
        this.trail({
          type: "questionnaire-isQualified",
          questionnaire: this.identifier,
        });
      }
      return this.stats.qualified;
    },
    inProcess() {
      const scores = this.stats.scores || [];
      return scores[1] + scores[2] + scores[3] > 0;
    },
  },
  data: () => ({
    questionnaire: {
      title: "",
    },
    selection: [],
    question: null,
    selectedAnswer: null,
    errors: [],
    showCertificate: true,
  }),
};
</script>

<style scoped>
.questionarea {
  margin: 1% 2%;
}

.questioncard.true {
  background-color: rgb(5, 90, 5) !important;
}
.questioncard.false {
  background-color: rgb(160, 20, 20) !important;
}
.questioncard-content {
  min-height: 80vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-top: 2rem;
}
.md-card-content ul {
  padding-left: 0;
}
.questioncard li {
  list-style: none;
  margin-bottom: 1rem;
  padding: 4%;
  border: 2px solid rgba(255, 255, 255, 0);
}
input[type="checkbox"] {
  display: none;
}

.checked {
  border: 2px solid white !important;
}
.answer-icon {
  color: white !important;
}
</style>
